import type { SnackNewItem_SnackEditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateSnackModel } from "../use-create-snack-editor-model";
import { useCreateSnackFormModel } from "../use-create-snack-form-model";

type Props = {
	hotelID: string;
	data: SnackNewItem_SnackEditPageQuery;
};

export const useInit = ({ hotelID, data }: Props) => {
	const snackFormModel = useCreateSnackFormModel({ hotelID, data: data.snackNewItem });

	return {
		...useCreateSnackModel({ hotelID, data, snackFormModel }),
		snackFormModel,
	};
};
